// APP UTIL IMPORTS
import {
  getDateTimeLocale,
  setDateTimeConfig,
  getDateTimeObjFromDateParts,
  getMaskedGBODate,
  getDateTimeObjFromTs,
  getCurrentDateTimeObj,
  parseGBODate,
  getDateTimeObj,
  getMonthsArray,
  getUTCTime,
  getGBOTimeStamp,
  setDefaultTime,
  getDefaultDateTimeObj
} from './app/dateTime';
import {getKilometersBetweenPoints, getRegionForCoordinates, getSearchRadiusForRegion} from './app/maps';
import {getFormattedMessages} from './app/messages';
import {
  getContractDetails,
  getCouponsDetails,
  getFormattedReservationExtras,
  getRentersAgeOptions,
  getReservationDeepLinkParams,
  getReservationDeepLinkQs,
  getVehicleRatesFromReservation,
  getVehicleSelectLabelByCode,
  isTimeInRange,
  isLocationAvailableByTime,
  isLocationAvailableByDate,
  isLocationAvailableByDateTime,
  getTimeFrames,
  getTimeWithMeridiem,
  formatTimeStamp
} from './app/reservations';
import request from './app/request';
import {getUidByPrefix, resetUidByPrefix, uid} from './app/uid';
import { reshapeVehicleCategoriesData, mergeVehicleData } from './app/vehicles';
import {filterObjectsByKeyValues, filterObjectsByMultipleKeyValues, isArrayNotEmpty, sortArrayOfObjectsByKey, sortArrayOfObjectsByKeyPath} from './js/array';
import {debounce} from './js/function';
import {get, getObjFromStrPairs, getQsFromObj, isObjectEmpty} from './js/object';
import { removePrecedingAndTraillingSpaces } from './js/string';
import {types} from './js/types';
import {createScriptTag, generateBrowserTabId} from './js/window';
import {getGmiConstants} from './app/constants';
import {Timeout} from './app/sessionTimeout';

import { getCountryFieldRules } from './app/locations';

/**
 * @namespace "utils"
 */
export default {
  // app utils
  // date time
  getCurrentDateTimeObj, getDateTimeLocale, getDateTimeObjFromDateParts, getDateTimeObjFromTs, 
  getMaskedGBODate, getGBOTimeStamp, setDefaultTime, getDefaultDateTimeObj,
  setDateTimeConfig, parseGBODate, getDateTimeObj, getMonthsArray, getUTCTime,
  // gbo messages
  getFormattedMessages,
  // map trig
  getKilometersBetweenPoints,
  getRegionForCoordinates,
  getSearchRadiusForRegion,
  // reservations
  getContractDetails,
  getCouponsDetails,
  getFormattedReservationExtras,
  getRentersAgeOptions,
  getReservationDeepLinkParams,
  getReservationDeepLinkQs,
  getVehicleRatesFromReservation,
  getVehicleSelectLabelByCode,
  isTimeInRange,
  isLocationAvailableByTime,
  isLocationAvailableByDate,
  isLocationAvailableByDateTime,
  getTimeFrames,
  getTimeWithMeridiem,
  formatTimeStamp,
  // xhr/http requests
  request,
  // uid
  getUidByPrefix, resetUidByPrefix, uid,
  // vehicles
  reshapeVehicleCategoriesData,
  mergeVehicleData,
  // country rules
  getCountryFieldRules,

  // js helper utils
  // filters
  filterObjectsByKeyValues, filterObjectsByMultipleKeyValues, isArrayNotEmpty, sortArrayOfObjectsByKey, sortArrayOfObjectsByKeyPath,
  // functions
  debounce,
  // objects
  get, getObjFromStrPairs, getQsFromObj, isObjectEmpty,
  // types
  types,
  // window
  createScriptTag,
  generateBrowserTabId,
  //string
  removePrecedingAndTraillingSpaces,

  // constants
  getGmiConstants,

  // custom timeout
  setCustomTimeout: Timeout.setCustomTimeout,
  // custom callback on timeout timer
  setTickCallBack: Timeout.setTickCallback,
  // getter for Timeout.initialValue
  getInitialTimeout: () => Timeout.initialValue,
  // function from Timeout module
  stopSessionTimeoutTimer: Timeout._stopTimer
};
